var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChipLabelInput',{attrs:{"value":_vm.value,"chip-placeholder":'{{pivot_label}}',"chip-label":_vm.chipDisplayLabel,"chip-tooltip":_vm.hasPivot ? 'Pivot dimension value will be inserted at chip position' : '',"show-add-button":_vm.hasPivot},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }